export default function ReadMoreButton() {
  return (
    <span className=" flex flex-1 justify-center items-center gap-2 rounded-[8px] border border-[#000000]/10 px-4 py-2 text-xs font-bold text-gray-900 transition-colors group-hover:border-gray-900 group-hover:bg-gray-900 group-hover:text-white">
      Read more
      <svg
        className="h-3.5 w-3.5"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        aria-hidden="true"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M4 12h15m-6-6 6 6-6 6"
        />
      </svg>
    </span>
  );
}
